import {Stack, Typography} from "@mui/material";
import type {GridColDef} from "@mui/x-data-grid-premium";
import {formatDate} from "~/components/data-grid/cells/gridCellFormat";
import {centered} from "~/components/data-grid/cells/gridCells";
import type {ChainUnlock} from "~/pages/supplier-360/tabs/SupplierValueChain/valueChainCreditTypes";
import {SupplierNameAvatar} from "~/pages/supplier-360/components/SupplierNameAvatar";

/**
 * The credits page's "companies mapped" table (`ChainCreditsPage` in the design). Client-side over
 * the unpaginated `chain_unlock` list, which carries each unlocked supplier's `canonical_name` and
 * `logo_url` (§2.15).
 */
export function getMappedCompaniesColumns(): GridColDef<ChainUnlock>[] {
    return [
        {
            field: 'entity',
            headerName: 'Company',
            flex: 2,
            minWidth: 240,
            valueGetter: (_value, row) => row.canonical_name,
            renderCell: ({row}) => (
                <Stack direction="row" alignItems="center" gap={1} sx={{height: '100%', minWidth: 0}}>
                    <SupplierNameAvatar name={row.canonical_name} entityId={row.entity} logoUrl={row.logo_url} size={24}/>
                    <Typography variant="body2" noWrap>{row.canonical_name}</Typography>
                </Stack>
            ),
        },
        {
            field: 'unlocked_at',
            headerName: 'Mapped on',
            type: 'date',
            flex: 1,
            minWidth: 160,
            valueGetter: (_value, row) => new Date(row.unlocked_at),
            renderCell: ({row}) => centered(<Typography variant="body2">{formatDate(row.unlocked_at)}</Typography>),
        },
        {
            field: 'unlocked_by',
            headerName: 'Mapped by',
            flex: 1,
            minWidth: 180,
        },
    ];
}
